import { OrderStatus, OrderItemStatus } from 'types';

export const orderStatusToText = (status: OrderStatus | OrderItemStatus) => {
  switch (status) {
    case OrderStatus.Processing:
      return 'Registrerat';
    case OrderStatus.PartiallyConfirmed:
      return 'Delvis bekräftad';
    case OrderStatus.Confirmed:
      return 'Bekräftad';
    case OrderStatus.PartiallyAllocated:
      return 'Delvis plockad';
    case OrderStatus.Allocated:
      return 'Plockas';
    case OrderStatus.Blocked:
      return 'Stoppad';
    case OrderStatus.PartiallyDelivered:
      return 'Delvis skickad';
    case OrderStatus.Delivered:
      return 'Skickad';
    case OrderStatus.PartiallyInvoiced:
      return 'Delvis fakturerad';
    case OrderStatus.Invoiced:
      return 'Fakturerad';
    default:
      return 'Okänd';
  }
};

export const orderItemStatusToText = (status: OrderItemStatus) => {
  switch (status) {
    case OrderItemStatus.Processing:
      return 'Registrerat';
    case OrderItemStatus.Confirmed:
      return 'Bekräftad';
    case OrderItemStatus.Allocated:
      return 'Plockas';
    case OrderItemStatus.Blocked:
      return 'Stoppad';
    case OrderItemStatus.Delivered:
      return 'Skickad';
    case OrderItemStatus.Invoiced:
      return 'Fakturerad';
    default:
      return 'Okänd';
  }
};
